import Typography from '@material-ui/core/Typography';
import * as React from 'react';

import { useStyles } from './styles';

type HeaderProps = {
  title: string;
};

function Header({ title }: HeaderProps) {
  const classes = useStyles();

  return (
    <header className={classes.container}>
      <Typography variant='h6'>
        <strong>{title}</strong>
      </Typography>
      <span className={classes.news}>Novidade</span>
    </header>
  );
}

export { Header };
